export default {
	/*
	addListSaveRows_: function (state) {
		return state.variableManagements.filter(el => el.tableState === 'I' || el.tableState === 'U');
	},
	*/
	totalSize_: state => {
		const { totalSize } = state.pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pageUnit } = state.pagingInfo;
		return pageUnit;
	},
	getStartDt_: ({ searchParams }) => searchParams.strtDt
};
